import { Maybe, MaybeUndef } from 'types/UtilityTypes';

const FLAT_CHARGE_PATTERN =
  /^\$?\s*(\d+(?:\.\d+)?)\s*\/\s*(shipment|occurrence|trailer|load)\b/i;

const FLAT_CHARGE_REJECT = [
  'pass-through',
  'pass through',
  'quoted',
  'negotiated',
  'lesser',
  '%',
  'percent',
  'first stop',
  'second stop',
  'after ',
  'prevailing',
  'out-of-route',
  'out of route',
  '+',
  'max ',
];

// Returns a dollar amount only for unambiguous flat fees like "$100/shipment".
export function parseFlatAccessorialCharge(
  charge: MaybeUndef<string>
): Maybe<number> {
  const text = (charge ?? '').trim();
  if (!text) {
    return null;
  }

  const lower = text.toLowerCase();
  if (FLAT_CHARGE_REJECT.some((token) => lower.includes(token))) {
    return null;
  }

  const match = FLAT_CHARGE_PATTERN.exec(text);
  if (!match) {
    return null;
  }

  const amount = Number.parseFloat(match[1]);
  if (!Number.isFinite(amount) || amount <= 0) {
    return null;
  }

  return amount;
}

export function sumFlatAccessorialCharges(
  charges: Array<MaybeUndef<{ charge?: Maybe<string> }>>
): number {
  return charges.reduce((sum, item) => {
    const amount = parseFlatAccessorialCharge(item?.charge);
    return amount == null ? sum : sum + amount;
  }, 0);
}
